import { push } from '@lagunovsky/redux-react-router'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import Icon from '../../../../../Icon/Icon'
import { PAGE_NAME } from '../../../../../OrderStepsHeader/constants'
import Typography from '../../../../../Typography/Typography'
import { useCountdown } from '../../../../hooks/useCountdown'

import './ShoppingCart.scss'

const ShoppingCart = ({ tickets, basketValidity, basketRelease }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const minutesRemain = useCountdown(basketValidity, basketRelease, 'expired-limit')

    return (
        <div
            role="button"
            className={`shopping-cart d-flex align-items-center pe-auto gap-2 ${!tickets && 'd-none'}`}
            onClick={() => dispatch(push(`/${PAGE_NAME.yourOrder}`))}
        >
            <Icon name={'basket'} className={'pb-1'} />
            <Typography variant={'containerSBody'} color={'magentaSecondary'}>
                {tickets}
            </Typography>
            <Typography variant={'label'} className={'non-mobile'}>
                {intl.formatMessage(
                    {
                        id: 'header.shoppingCart.tickets',
                    },
                    {
                        count: tickets,
                    }
                )}
            </Typography>
            <div className={'non-mobile border-start border-end opacity-25 py-3 ms-1'} />
            <Icon name={'countdown'} className={'pb-1 ms-1'} />
            <Typography variant={'containerSBody'} color={'magentaSecondary'}>
                {minutesRemain}
            </Typography>
            <Typography variant={'label'} className={'non-mobile'}>
                {intl.formatMessage(
                    {
                        id: 'header.shoppingCart.minutes',
                    },
                    {
                        count: minutesRemain,
                    }
                )}
            </Typography>
        </div>
    )
}

export default ShoppingCart
